import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {RequestService} from '../request/request.service';
import {Observable} from 'rxjs';
import {GroupListModel} from '../../../shared/models/group.model';

@Injectable()
export class GroupService {
  apiUrl = environment.apiRoot;

  constructor(private reqService: RequestService) { }

  get(filter?): Observable<GroupListModel> {
    const req = {
      url: this.apiUrl + 'Group',
      options: {
        params: filter
      }
    };

    return this.reqService.getRequest(req);
  }

  read(id): Observable<GroupListModel> {
    const req = {
      url: this.apiUrl + 'Group/' + id
    };

    return this.reqService.getRequest(req);
  }

  create(object) {
    const req = {
      url: this.apiUrl + 'Group',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  remove(object) {
    const req = {
      url: this.apiUrl + 'Group/RemoveGroup',
      options: {
        params: object
      }
    };

    return this.reqService.postRequest(req);
  }

  changeName(object) {
    const req = {
      url: this.apiUrl + 'Group/ChangeName',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  addUnit(object) {
    const req = {
      url: this.apiUrl + 'Group/AddUnit',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  getGroupAddresses(id) {
    const req = {
      url: this.apiUrl + 'Group/' + id + '/GroupAddresses'
    };

    return this.reqService.getRequest(req);
  }

  createGroupAddress(object) {
    const req = {
      url: this.apiUrl + 'Group/CreateGroupAddress',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  updateGroupAddress(object)
  {
    const req = {
      url: this.apiUrl + 'Group/updateGroupAddress',
      data: object
    };

    return this.reqService.putRequest(req);
  }

  removeGroupAddress(object)
  {   
    console.log(object); 
    const req = {
      url: this.apiUrl + 'Group/RemoveGroupAddress',
      data: object
    };

    return this.reqService.deleteRequest(req);     
  }

}
